export type ModelsLibraryFilter = "all" | "draft" | "in_review" | "active";

export const MODEL_LIBRARY_FILTER_ITEMS: Array<{
  value: ModelsLibraryFilter;
  label: string;
}> = [
  { value: "all", label: "All" },
  { value: "draft", label: "Draft" },
  { value: "in_review", label: "In review" },
  { value: "active", label: "Active" },
];
